"use strict";

exports.__esModule = !0, exports.LIB_NAME = void 0;
var LIB_NAME = "react-dropdown-select";
exports.LIB_NAME = "react-dropdown-select";